import { render, staticRenderFns } from "./InventoryCreateEdit.vue?vue&type=template&id=5fc45190&scoped=true&"
import script from "./InventoryCreateEdit.vue?vue&type=script&lang=js&"
export * from "./InventoryCreateEdit.vue?vue&type=script&lang=js&"
import style0 from "./InventoryCreateEdit.vue?vue&type=style&index=0&id=5fc45190&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc45190",
  null
  
)

export default component.exports